import React from 'react';
import { Modal, Switch, Tooltip, message } from 'antd';
import { useUpdateTeam } from '../../hooks/useUpdateTeam';

type Props = {
  isHidden?: boolean;
  teamId: number;
  refetchTeam: () => void;
  disabled?: boolean;
};

const HideTeam = ({ isHidden, teamId, refetchTeam, disabled }: Props) => {
  const { onSubmit, isLoading } = useUpdateTeam(refetchTeam);

  const handleConfirm = async () => {
    try {
      await onSubmit({ is_hidden: !isHidden }, teamId);
      message.success(
        `Team has been ${isHidden ? 'unhidden' : 'hidden'} successfully.`
      );
      refetchTeam();
    } catch {
      message.error(
        `Failed to ${isHidden ? 'unhide' : 'hide'} the team. Please try again.`
      );
    }
  };

  const handleChange = () => {
    Modal.confirm({
      title: isHidden ? 'Unhide Team' : 'Hide Team',
      content: `Are you sure you want to ${
        isHidden ? 'unhide' : 'hide'
      } this team?`,
      onOk: handleConfirm,
    });
  };

  const getTooltipTitle = () => {
    if (disabled && isHidden)
      return "This team is hidden. You don't have permission to change it.";
    if (disabled)
      return "This team is visible. You don't have permission to change it.";
    if (isHidden) return 'This team is hidden. Click to make it visible.';
    return 'This team is visible. Click to hide it from the platform.';
  };

  return (
    <Tooltip title={getTooltipTitle()}>
      <Switch
        checked={isHidden}
        onChange={handleChange}
        disabled={disabled}
        loading={isLoading}
      />
    </Tooltip>
  );
};

export default HideTeam;
